import { useLayoutEffect, useRef } from 'react';

/**
 * 모달 등이 열렸을 때 body 스크롤을 막는 hook (모바일 뷰포트/키보드 문제 최종 개선)
 * @param {boolean} isLocked - true일 때 스크롤 잠금
 */
const useLockScroll = (isLocked) => {
    // 스크롤 위치 저장을 위한 ref
    const scrollY = useRef(0);
    // body와 html의 원본 스타일 저장을 위한 ref
    const originalStyleBody = useRef({});
    const originalStyleHtml = useRef({}); // <html> 태그용

    useLayoutEffect(() => {
        const body = document.body;
        const html = document.documentElement; // <html> 태그 선택

        if (isLocked) {
            // 현재 스크롤 위치 및 원본 스타일 저장
            scrollY.current = window.scrollY;

            originalStyleBody.current = {
                overflow: body.style.overflow,
                position: body.style.position,
                width: body.style.width,
                top: body.style.top,
            };
            originalStyleHtml.current = { // <html> 스타일 저장
                overflow: html.style.overflow,
            };

            // body와 html 스타일 변경 (스크롤 잠금)
            html.style.overflow = 'hidden'; // <html>도 hidden
            body.style.overflow = 'hidden';
            body.style.position = 'fixed';
            body.style.width = '100%';
            body.style.top = `-${scrollY.current}px`; // 현재 스크롤 위치로 고정

            // 복구 함수
            return () => {
                html.style.overflow = originalStyleHtml.current.overflow; // <html> 복구

                body.style.overflow = originalStyleBody.current.overflow;
                body.style.position = originalStyleBody.current.position;
                body.style.width = originalStyleBody.current.width;
                body.style.top = originalStyleBody.current.top;

                // 스크롤 위치 즉시 복구
                window.scrollTo(0, scrollY.current);
            };
        }
    }, [isLocked]); // isLocked 상태가 변경될 때만 실행
};

export default useLockScroll;